import { render, staticRenderFns } from "./AllKillList.vue?vue&type=template&id=15ff8797&"
import script from "./AllKillList.vue?vue&type=script&lang=js&"
export * from "./AllKillList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports